import React from 'react';
import { LuMail } from 'react-icons/lu';
import { Link } from 'react-router-dom';

const ERROR_MESSAGES: Record<string, string> = {
  invalid_or_expired: 'This verification link is invalid or has expired. Request a new one from Integrations.',
  missing_token: 'This verification link is missing its token. Request a new one from Integrations.',
};

const ConnectEmailPage: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const status = params.get('status');
  const errorCode = params.get('error');
  const errorMessage = errorCode ? (ERROR_MESSAGES[errorCode] ?? 'Verification failed. Please try again.') : null;

  return (
    <div className="min-h-screen bg-base-200 flex items-center justify-center p-4">
      <div className="card bg-base-100 shadow-xl w-full max-w-sm">
        <div className="card-body gap-4 items-center text-center">
          <LuMail className="text-4xl text-emerald-500" />

          {status === 'connected' && (
            <>
              <h2 className="card-title font-display">Email Connected</h2>
              <p className="text-sm opacity-70">Your email is verified — notifications can now be sent to it.</p>
              <Link to="/integrations" className="btn btn-primary btn-sm">
                Back to Integrations
              </Link>
            </>
          )}

          {errorMessage && (
            <>
              <h2 className="card-title font-display text-error">Email Verification Error</h2>
              <div className="alert alert-error">
                <span className="text-sm">{errorMessage}</span>
              </div>
              <Link to="/integrations" className="btn btn-ghost btn-sm">
                Back to Integrations
              </Link>
            </>
          )}

          {!status && !errorMessage && (
            <p className="text-sm opacity-70">
              Nothing to confirm here — open the link from your verification email instead.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConnectEmailPage;
